import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { useBuildStore } from "~/components/build/Show/lib/useBuildStore";

/**
 * Get jobs from the build store.
 */
export function useJobs() {
  const { store } = useBuild();
  const jobs = useBuildStore((state) => state.jobs);

  return Features.ProgressiveBuildShow ? jobs : store.jobs;
}
